export default "/institutions/caju.svg";